import React, { useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import SideContent from "./SideContent";
import MainContent from "./MainContent";

const EmailPage = () => {
  const [activeTab, setActiveTab] = useState("inbox");

  const handleTabClick = (tab: any) => {
    setActiveTab(tab);
  };

  const [selectedMail, setSelectedMail] = useState(false)

  const toggleMail = (e: boolean) => {
    setSelectedMail(!selectedMail)
  }

  return (
    <React.Fragment>
      <BreadCrumb title="Email" pageType="Apps" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="min-h-[calc(100vh-212px)]">
          <div
            className="flex flex-col items-start gap-4 tabs md:flex-row"
          >
            {/* side */}
            <SideContent
              handleTabClick={handleTabClick}
              activeTab={activeTab}
            />
            {/* main */}
            <MainContent activeTab={activeTab} selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EmailPage;
